import { jsx as _jsx } from "react/jsx-runtime";
import { TranslatableString } from '@rjsf/utils';
import Button from 'react-bootstrap/Button';
import { IoIosCopy } from '@react-icons/all-files/io/IoIosCopy';
import { IoIosRemove } from '@react-icons/all-files/io/IoIosRemove';
import { AiOutlineArrowUp } from '@react-icons/all-files/ai/AiOutlineArrowUp';
import { AiOutlineArrowDown } from '@react-icons/all-files/ai/AiOutlineArrowDown';
export default function IconButton(props) {
    const { icon, iconType, className, uiSchema, registry, ...otherProps } = props;
    return (_jsx(Button, { block: iconType === 'block', ...otherProps, variant: props.variant || 'light', size: 'sm', children: icon }));
}
export function CopyButton(props) {
    const { registry: { translateString }, } = props;
    return _jsx(IconButton, { title: translateString(TranslatableString.CopyButton), ...props, icon: _jsx(IoIosCopy, {}) });
}
export function MoveDownButton(props) {
    const { registry: { translateString }, } = props;
    return (_jsx(IconButton, { title: translateString(TranslatableString.MoveDownButton), ...props, icon: _jsx(AiOutlineArrowDown, {}) }));
}
export function MoveUpButton(props) {
    const { registry: { translateString }, } = props;
    return _jsx(IconButton, { title: translateString(TranslatableString.MoveUpButton), ...props, icon: _jsx(AiOutlineArrowUp, {}) });
}
export function RemoveButton(props) {
    const { registry: { translateString }, } = props;
    return (_jsx(IconButton, { title: translateString(TranslatableString.RemoveButton), ...props, variant: 'danger', icon: _jsx(IoIosRemove, {}) }));
}
//# sourceMappingURL=IconButton.js.map